export default "__VITE_ASSET__BUYPMHno__ 500w";